import MasterLayout from 'components/layouts/MasterLayout'
import { LoadingBarProcess } from 'components/loadingProcess/LoadingBarProcess'
import React from 'react'
import { Route, Routes } from 'react-router-dom'

const HistoryPage = React.lazy(() => import('pages/history/HistoryPage'))

const HistoryRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<MasterLayout />}>
        <Route
          index
          element={
            <React.Suspense fallback={<LoadingBarProcess />}>
              {/* <RequireAuth> */}
                <HistoryPage />
              {/* </RequireAuth> */}
            </React.Suspense>
          }
        />
      </Route>
    </Routes>
  )
}

export default HistoryRoutes